import axios from 'axios';

// CRITICAL: Hardcoded production URL to prevent .env reset issues
// The .env file keeps getting overwritten during deployments
const PRODUCTION_URL = 'https://app.dailydiscipline.app';

// Backend URL configuration.
// IMPORTANT: We decide the backend from the RUNTIME hostname (window.location),
// NOT from REACT_APP_BACKEND_URL — because the deploy process can bake a preview
// URL into the production build. Runtime detection keeps production stable while
// still letting the Emergent preview environment reach its own backend.
const envUrl = process.env.REACT_APP_BACKEND_URL || '';

function resolveBackendUrl() {
  // Local development: frontend on :3000, backend on :8001 (from env)
  if (envUrl.includes('localhost') || envUrl.includes('127.0.0.1')) {
    return envUrl;
  }
  if (typeof window !== 'undefined' && window.location) {
    const host = window.location.hostname;
    // Emergent preview environment -> backend is same-origin as this preview domain
    if (host.endsWith('.emergentagent.com')) {
      return window.location.origin;
    }
  }
  // Production (custom domain) -> always the production backend
  return PRODUCTION_URL;
}

export const BACKEND_URL = resolveBackendUrl();
export const API = `${BACKEND_URL}/api`;

// CRITICAL: Hardcoded Stripe public key to prevent .env reset issues
// The .env file keeps getting overwritten with wrong test keys during deployments
const STRIPE_LIVE_PUBLIC_KEY = 'pk_live_51S32hdH0r8BD1ydq4JFBbPSUADuDYfY5lwTK9Gs2z03UurszJKLxYrAqqRN8qqGv25oKIEhQzLL1jUhY4QGMFi0H00YzML03JU';
export const STRIPE_PUBLIC_KEY = (envUrl.includes('localhost') || envUrl.includes('127.0.0.1')) ? (process.env.REACT_APP_STRIPE_PUBLIC_KEY || STRIPE_LIVE_PUBLIC_KEY) : STRIPE_LIVE_PUBLIC_KEY;

// STRIPE PAYMENT LINKS - Direct links that bypass backend API issues
// These are hardcoded to ensure payments always work regardless of backend key configuration
export const STRIPE_PAYMENT_LINKS = {
  MONTHLY: 'https://buy.stripe.com/7sY9ATbqG8Ssekegy514406',      // $7/month subscription
  ANNUAL: 'https://buy.stripe.com/28EbJ1amCgkUa3Ygy514405',       // $49/year subscription
  GIFT_90DAY: 'https://buy.stripe.com/bJefZhamCb0Aa3Y1Db14404',   // $19 - 90-Day Jumpstart gift
  GIFT_YEAR: 'https://buy.stripe.com/28E5kDcuKd8I4JEbdL14403',    // $49 - 1 Year of Growth gift
};

// Configure axios to send cookies
axios.defaults.withCredentials = true;

// Image URLs
export const HERO_IMAGE = 'https://customer-assets.emergentagent.com/job_daily-discipline-v4/artifacts/x67kvzr3_D2%20hero%20image.png';
export const LOGO_DARK = 'https://customer-assets.emergentagent.com/job_daily-discipline-26/artifacts/htyek3bu_logo-transparent%20on%20black%20background.png';
export const LOGO_LIGHT = 'https://customer-assets.emergentagent.com/job_daily-discipline-26/artifacts/20ty815f_logo-transparent-white.png';

// Timezone options for settings
export const TIMEZONE_OPTIONS = [
  { value: 'America/New_York', label: 'Eastern Time (ET)' },
  { value: 'America/Chicago', label: 'Central Time (CT)' },
  { value: 'America/Denver', label: 'Mountain Time (MT)' },
  { value: 'America/Los_Angeles', label: 'Pacific Time (PT)' },
  { value: 'America/Anchorage', label: 'Alaska Time (AKT)' },
  { value: 'Pacific/Honolulu', label: 'Hawaii Time (HT)' },
  { value: 'Europe/London', label: 'London (GMT/BST)' },
  { value: 'Europe/Paris', label: 'Paris (CET)' },
  { value: 'Europe/Berlin', label: 'Berlin (CET)' },
  { value: 'Asia/Tokyo', label: 'Tokyo (JST)' },
  { value: 'Asia/Shanghai', label: 'Shanghai (CST)' },
  { value: 'Asia/Dubai', label: 'Dubai (GST)' },
  { value: 'Asia/Kolkata', label: 'India (IST)' },
  { value: 'Australia/Sydney', label: 'Sydney (AEST)' },
  { value: 'Africa/Johannesburg', label: 'Johannesburg (SAST)' },
  { value: 'Africa/Harare', label: 'Harare (CAT)' },
  { value: 'Africa/Lagos', label: 'Lagos (WAT)' },
  { value: 'Africa/Cairo', label: 'Cairo (EET)' },
];
